'use client'
// import { AnimatePresence, motion, Variants } from 'framer-motion'
import { cn } from '../helpers/classnames'
import { SIconButton } from '../button/s-icon-button'
import { ReactNode } from 'react'
import { Portal } from '../portal'
import Heading from '../typeography/heading'
import {
  ChevronDoubleLeftIcon,
  ChevronDoubleRightIcon,
} from '@heroicons/react/16/solid'

interface SlideMenuProps {
  is_open: boolean
  direction?: 'left' | 'right'
  children: ReactNode
  className?: string
  title?: string
  onClose?: () => void
}

const SlideMenu = ({
  is_open,
  direction = 'left',
  children,
  className = 'w-80',
  title,
  onClose,
}: SlideMenuProps) => {
  // const slideVariants: Variants = {
  //   open: {
  //     x: 0,
  //     opacity: 1,
  //     transition: {
  //       type: 'tween',
  //       duration: 0.25,
  //       ease: 'easeInOut',
  //       opacity: { duration: 0.3 },
  //     },
  //   },
  //   closed: {
  //     x: direction === 'left' ? '-100%' : '100%',
  //     opacity: 0,
  //     transition: {
  //       type: 'tween',
  //       duration: 0.3,
  //       ease: 'easeInOut',
  //     },
  //   },
  // }

  const positionClasses =
    direction === 'left' ? 'inset-y-0 left-0 ' : 'inset-y-0 right-0'

  // CSS transition classes for slide animation
  const slideClasses = is_open
    ? 'translate-x-0 opacity-100'
    : direction === 'left'
    ? '-translate-x-full opacity-0 pointer-events-none'
    : 'translate-x-full opacity-0 pointer-events-none'
  
  return (
    <div>
      {/* Backdrop blur overlay */}
      <div
        className={cn(
          'fixed inset-0 z-[9998]',
          'bg-black/20 dark:bg-black/40 backdrop-blur-sm',
          'transition-opacity duration-300',
          is_open ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={onClose}
      />
      
      {/* <AnimatePresence> */}
        <div
          className={cn(
            'fixed z-[9999] h-full p-2',
            positionClasses,
            'flex-1 py-2 overflow-hidden',
            className,
            // CSS transitions for smooth animation
            'transition-all duration-300 ease-in-out',
            slideClasses
          )}
          // initial="closed"
          // animate={is_open ? 'open' : 'closed'}
          // exit="closed"
          // variants={slideVariants}
          onClick={(e) => {
            // stop the click from propagating to the parent
            e.stopPropagation()
          }}
        >
          <div
            className={cn(
              'flex flex-col overflow-hidden h-full  border-black/10 dark:border-white/10 bg-neutral-200/95 dark:bg-neutral-800/95 backdrop-blur-xl rounded-lg'
            )}
          >
            {(title || onClose) && (
              <div
                className={cn(
                  'sticky top-0 flex justify-between items-center py-2 z-20',
                  {
                    'flex-row-reverse pl-2 pr-4': direction === 'right',
                    'pl-4 pr-2': direction === 'left',
                  }
                )}
              >
                {title && (
                  <Heading
                    className={cn('pl-2', {
                      'text-right': direction === 'right',
                    })}
                  >
                    {title}
                  </Heading>
                )}
                {onClose && (
                  <SIconButton
                    icon={
                      direction === 'left'
                        ? ChevronDoubleLeftIcon
                        : ChevronDoubleRightIcon
                    }
                    variant={'ghost_default'}
                    onClick={onClose}
                    className="relative z-10"
                  >
                    Close
                  </SIconButton>
                )}
              </div>
            )}
            <div className="flex-1 relative  h-full overflow-scroll">
              {children}
            </div>
          </div>
        </div>
      {/* </AnimatePresence> */}
    </div>
  )
}

export default SlideMenu
